module.exports = __webpack_public_path__ + "static/media/isoquercetina-logo.5a0be3ba.svg";